import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';
import { performGetRequest } from '@atlassian/jira-fetch';
import type { ApplicationKey } from '@atlassian/jira-shared-types';

import { UPGRADE_ONBOARDING_PRODUCT_TRAIT_MAP } from './constants';
import type { PersonalizationApiTrait } from './types';

export const fetchSiteTraits = async (cloudId: string): Promise<PersonalizationApiTrait[]> => {
	try {
		const url = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
		const response = await performGetRequest(url);
		if (response?.attributes) {
			return response.attributes;
		}
		throw Error('response is not defined or null');
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			meta: {
				id: 'jiraUpgradeOnboardingExperiment',
				packageName: 'jiraUpgradeOnboardingExperiment',
				teamName: 'transmuters-growth',
			},
			error,
			sendToPrivacyUnsafeSplunk: true,
		});
	}
	return [];
};

export const isUpgradedFromFreeToPaid = async (
	cloudId: string,
	product: ApplicationKey,
): Promise<boolean> => {
	const response = await fetchSiteTraits(cloudId);
	return response.some((trait) =>
		UPGRADE_ONBOARDING_PRODUCT_TRAIT_MAP.get(product)?.includes(trait.name),
	);
};

export const isUpgradedBasedOnTraits = async (
	product: ApplicationKey,
	cloudId: string,
	transactionAccountId?: string | null,
): Promise<boolean> => {
	// normally the trait can be retrieved with just the cloud id but if it was a manual upgrade from
	// ccp, we also need to check the personalization api with the transactionAccountId
	let isUpgraded = await isUpgradedFromFreeToPaid(cloudId, product);
	// transactionAccountId is needed when it is a manual upgrade from a ccp account
	if (transactionAccountId && !isUpgraded) {
		isUpgraded = await isUpgradedFromFreeToPaid(transactionAccountId, product);
	}
	return isUpgraded;
};
